import { useEffect } from 'react'

import { events } from '../../../analytics/events'
import { track } from 'utils/analytics'
import { UserTerm } from 'types/internal'

import { useUser } from 'contexts/user'
import CommitmentDetails from './CommitmentDetails'
import DeliverySettings from './DeliverySettings'
import EditPlan from './EditPlan'
import ManageOrders from './ManageOrders'
import MealPlanPreferences from './MealPlanPreferences'
import ProfileHeading from './AccountHeading'

const MealPlan = ({
  onEditTermStatus,
}: {
  onEditTermStatus(userTerm: UserTerm): void
}) => {
  const { user } = useUser()

  const isSubscriptionActive = user.subscription.status === 'active'

  useEffect(() => {
    track(events.OPENS_MEAL_PLAN_SETTINGS)
  }, [])

  return (
    <div className="w-full max-w-account">
      <div className="md:hidden">
        <MealPlanDesktop
          isSubscriptionActive={isSubscriptionActive}
          onEditTermStatus={onEditTermStatus}
        />
      </div>
      <div className="hidden md:block">
        <MealPlanMobile isSubscriptionActive={isSubscriptionActive} />
      </div>
    </div>
  )
}

export default MealPlan

const MealPlanDesktop = ({
  isSubscriptionActive,
  onEditTermStatus,
}: {
  isSubscriptionActive: boolean
  onEditTermStatus(userTerm: UserTerm): void
}) => {
  return (
    <div>
      <h1 className="mb-10 text-k/44_110">Meal Plan</h1>

      <div className="space-y-8">
        <div className="space-y-4">
          <EditPlan />

          <DeliverySettings />

          {isSubscriptionActive && <MealPlanPreferences />}
        </div>

        {isSubscriptionActive && (
          <>
            <CommitmentDetails />

            <ManageOrders onEditTermStatus={onEditTermStatus} />
          </>
        )}
      </div>
    </div>
  )
}

const MealPlanMobile = ({
  isSubscriptionActive,
}: {
  isSubscriptionActive: boolean
}) => {
  return (
    <div className="mb-20">
      <ProfileHeading to="/account">Edit Plan</ProfileHeading>

      <EditPlan />

      {isSubscriptionActive && <CommitmentDetails />}
    </div>
  )
}
